(function () {
  'use strict';

  /* ============================================================
     OI : paliers de quantite - synchronisation avec le champ Quantite

     Sens 1 (palier -> quantite) : le clic ecrit la valeur dans tous les champs
     quantite de la section, emet 'input' et 'change' pour reveiller x-model
     d Alpine, et emet l evenement maison du theme Eurus
     'eurus:product:quantity-changed-<sectionId>' (c est exactement ce que fait
     deja le tableau de prix degressifs du theme, snippets/product-template.liquid).

     Sens 2 (quantite -> palier) : ecoute de 'input' et 'change' sur les champs,
     des clics sur les boutons plus / moins, de l evenement maison, plus un
     controle periodique de securite. Ce controle est necessaire car Alpine
     ecrit la valeur du champ par affectation directe (input.value = ...), ce
     qui ne declenche aucun evenement DOM : sans lui, un clic sur le bouton +
     du theme pourrait passer inapercu.
     ============================================================ */

  /* Passer a false pour desactiver le miroir de quantite dans la barre d achat
     collante (voir majFormulaireCollant plus bas). */
  var MIROIR_BARRE_COLLANTE = true;

  var PERIODE_CONTROLE = 400; /* millisecondes */
  var derniereValeur = {};    /* derniere quantite vue par section */
  var sectionsEcoutees = {};  /* evenements de variante deja branches */

  function chaque(liste, fn) {
    Array.prototype.forEach.call(liste || [], fn);
  }

  function blocs() {
    return document.querySelectorAll('[data-oi-paliers]');
  }

  /* Tous les champs quantite qui pilotent l ajout au panier de cette section.
     La fiche produit en expose deux (le bloc quantite et celui colle au bouton
     d achat) : ils doivent rester d accord, sinon la valeur envoyee a
     /cart/add depend de l ordre des champs dans le formulaire. */
  function champsQuantite(sectionId) {
    var liste = [];
    ['Quantity-' + sectionId, 'Quantity-atc-' + sectionId].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) liste.push(el);
    });
    chaque(
      document.querySelectorAll('input[name="quantity"][form="product-form-' + sectionId + '"]'),
      function (el) { if (liste.indexOf(el) === -1) liste.push(el); }
    );
    return liste;
  }

  function lireQuantite(sectionId) {
    var champs = champsQuantite(sectionId);
    for (var i = 0; i < champs.length; i++) {
      var v = parseInt(champs[i].value, 10);
      if (!isNaN(v)) return v;
    }
    return null;
  }

  /* Met en evidence le palier correspondant a la quantite courante.
     Si la quantite ne correspond a aucun palier (4, 7...), aucun palier n est
     marque : c est volontaire, on ne ment pas sur le prix affiche. */
  function marquer(bloc, qte) {
    var boutons = bloc.querySelectorAll('[data-oi-palier]');
    var trouve = false;
    chaque(boutons, function (b) {
      var n = parseInt(b.getAttribute('data-oi-palier'), 10);
      var actif = (n === qte);
      if (actif) trouve = true;
      b.classList.toggle('is-actif', actif);
      b.setAttribute('aria-checked', actif ? 'true' : 'false');
      b.setAttribute('tabindex', actif ? '0' : '-1');
    });
    /* Un groupe de boutons radio doit toujours garder un point d entree au
       clavier, meme quand aucun palier n est selectionne. */
    if (!trouve && boutons.length) {
      boutons[0].setAttribute('tabindex', '0');
    }
  }

  /* Le formulaire de la barre d achat collante ne contient aucun champ
     quantite : sans ce miroir, un achat depuis la barre ajouterait 1 article
     et le client perdrait le lot qu il vient de choisir juste au-dessus. */
  function majFormulaireCollant(sectionId, qte) {
    if (!MIROIR_BARRE_COLLANTE) return;
    var formulaire = document.getElementById('product-form-sticky-' + sectionId);
    if (!formulaire) return;
    var champ = formulaire.querySelector('input[data-oi-quantite-collante]');
    if (!champ) {
      champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = 'quantity';
      champ.setAttribute('data-oi-quantite-collante', '');
      formulaire.appendChild(champ);
    }
    champ.value = String(qte);
  }

  function synchroniser() {
    chaque(blocs(), function (bloc) {
      var sectionId = bloc.getAttribute('data-oi-section');
      if (!sectionId) return;
      var qte = lireQuantite(sectionId);
      if (qte === null) return;
      derniereValeur[sectionId] = qte;
      marquer(bloc, qte);
      majFormulaireCollant(sectionId, qte);
      brancherVariante(sectionId);
    });
  }

  function appliquer(sectionId, n) {
    var champs = champsQuantite(sectionId);
    chaque(champs, function (champ) {
      champ.value = String(n);
      /* 'input' reveille x-model d Alpine, 'change' les ecouteurs classiques. */
      champ.dispatchEvent(new Event('input', { bubbles: true }));
      champ.dispatchEvent(new Event('change', { bubbles: true }));

      /* Le bouton d ajout au panier affiche un prix multiplie par la quantite,
         recalcule par la methode updatePrice du composant xQuantitySelector.
         L evenement maison du theme ne l appelle pas : on va donc la chercher
         directement sur le composant Alpine, avec repli silencieux. */
      try {
        var enveloppe = champ.closest('[x-data]');
        if (window.Alpine && typeof window.Alpine.$data === 'function' && enveloppe) {
          var donnees = window.Alpine.$data(enveloppe);
          if (donnees && typeof donnees.updatePrice === 'function') {
            donnees.qty = n;
            donnees.updatePrice();
          }
        }
      } catch (e) { /* pas d Alpine : les evenements ci-dessus suffisent */ }
    });

    /* Convention du theme Eurus, ecoutee par xQuantitySelector. */
    document.dispatchEvent(new CustomEvent('eurus:product:quantity-changed-' + sectionId, {
      detail: { quantity: n }
    }));

    synchroniser();
  }

  /* Changement de variante : variant-select.js remplace le innerHTML de
     #price-<sectionId>, donc notre bloc est re-rendu par le serveur avec les
     montants de la nouvelle variante. Il ne reste qu a remettre la mise en
     evidence d accord avec le champ quantite, une fois le DOM remplace. */
  function brancherVariante(sectionId) {
    if (sectionsEcoutees[sectionId]) return;
    sectionsEcoutees[sectionId] = true;
    document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(synchroniser);
      });
    });
  }

  function surClic(evenement) {
    var cible = evenement.target;
    if (!cible || !cible.closest) return;

    var palier = cible.closest('[data-oi-palier]');
    if (palier) {
      var bloc = palier.closest('[data-oi-paliers]');
      if (!bloc) return;
      evenement.preventDefault();
      appliquer(bloc.getAttribute('data-oi-section'), parseInt(palier.getAttribute('data-oi-palier'), 10));
      return;
    }

    /* Boutons plus / moins du theme : Alpine ecrit la nouvelle valeur sans
       emettre d evenement, on relit donc apres le rendu. */
    if (cible.closest('button[name="plus"], button[name="minus"]')) {
      window.setTimeout(synchroniser, 0);
      window.requestAnimationFrame(synchroniser);
    }
  }

  function surSaisie(evenement) {
    var cible = evenement.target;
    if (cible && cible.name === 'quantity') synchroniser();
  }

  /* Navigation clavier attendue pour un groupe role="radio". */
  function surTouche(evenement) {
    var cible = evenement.target;
    if (!cible || !cible.closest) return;
    var palier = cible.closest('[data-oi-palier]');
    if (!palier) return;
    var pas = 0;
    if (evenement.key === 'ArrowRight' || evenement.key === 'ArrowDown') pas = 1;
    if (evenement.key === 'ArrowLeft' || evenement.key === 'ArrowUp') pas = -1;
    if (!pas) return;
    evenement.preventDefault();
    var bloc = palier.closest('[data-oi-paliers]');
    if (!bloc) return;
    var boutons = Array.prototype.slice.call(bloc.querySelectorAll('[data-oi-palier]'));
    var index = boutons.indexOf(palier);
    var suivant = boutons[(index + pas + boutons.length) % boutons.length];
    if (!suivant) return;
    appliquer(bloc.getAttribute('data-oi-section'), parseInt(suivant.getAttribute('data-oi-palier'), 10));
    suivant.focus();
  }

  /* Filet de securite : Alpine peut modifier la valeur du champ sans qu aucun
     evenement DOM ne soit emis. Une simple lecture de propriete toutes les
     400 ms ne declenche aucun calcul de mise en page et reste negligeable. */
  function controlePeriodique() {
    if (document.hidden) return;
    chaque(blocs(), function (bloc) {
      var sectionId = bloc.getAttribute('data-oi-section');
      if (!sectionId) return;
      var qte = lireQuantite(sectionId);
      if (qte === null) return;
      if (derniereValeur[sectionId] !== qte) {
        derniereValeur[sectionId] = qte;
        marquer(bloc, qte);
        majFormulaireCollant(sectionId, qte);
      }
    });
  }

  function demarrer() {
    if (!blocs().length) return;
    document.addEventListener('click', surClic, true);
    document.addEventListener('input', surSaisie, true);
    document.addEventListener('change', surSaisie, true);
    document.addEventListener('keydown', surTouche, true);
    /* Le tableau de prix degressifs du theme emet le meme evenement maison :
       on se met d accord avec lui aussi. */
    chaque(blocs(), function (bloc) {
      var sectionId = bloc.getAttribute('data-oi-section');
      if (!sectionId) return;
      document.addEventListener('eurus:product:quantity-changed-' + sectionId, function () {
        window.requestAnimationFrame(synchroniser);
      });
    });
    synchroniser();
    window.setInterval(controlePeriodique, PERIODE_CONTROLE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
